import React, { FunctionComponent, SVGProps, useContext } from 'react';

import { SHOW_CARD_WITHOUT_ANIMATION } from '../../store/constants';
import { StoreContext } from '../../store/store';
import { Label } from '../label/label';
import NavCard from '../nav-card/nav-card';
import { ShareSection } from '../share-section/share-section';
import { Title } from '../title/title';
import { Translate } from '../translate';
import './card.scss';

type CardBackProps = {
  title?: string;
  label?: string;
  labelColor?: string;
  nextCardId?: string;
  previousCardId?: string;
  backfaceIconSRC: string;
};

export const CardBack: React.FC<CardBackProps> = ({
  label,
  labelColor,
  title,
  children,
  nextCardId,
  previousCardId,
  backfaceIconSRC
}) => {
  const { dispatch } = useContext(StoreContext);

  return (
    <div className="bd-card__back__wrapper">
      <div className="bd-card__back">
        <div className="bd-card__back__header">
          <Label color={labelColor}>
            <Translate id={label} />
          </Label>
        </div>
        <div className="bd-card__back__content">
          <div className="bd-card__back__left-column">
            <Title level="2" weight="bold">
              <Translate id={title} />
            </Title>
            <div>{children}</div>
          </div>
          <div className="bd-card__back__right-column">
            <div className="bd-card__back__icon-wrapper">
              <img className="bd-card__back__icon-wrapper__icon" src={backfaceIconSRC} />
            </div>
          </div>
        </div>
      </div>

      <ShareSection className="bd-card__back__share" />

      <div className="bd-card__controls">
        {previousCardId && (
          <NavCard
            cardId={previousCardId}
            navText="translate.prev.lesson.button"
            navDirection="forward"
            onNav={() =>
              dispatch({
                type: SHOW_CARD_WITHOUT_ANIMATION,
                payload: { id: previousCardId }
              })
            }
          />
        )}

        {nextCardId && (
          <NavCard
            cardId={nextCardId}
            navText="translate.next.lesson.button"
            navDirection="backward"
            onNav={() =>
              dispatch({
                type: SHOW_CARD_WITHOUT_ANIMATION,
                payload: { id: nextCardId }
              })
            }
          />
        )}
      </div>
    </div>
  );
};
